import banners from '../../data/homepageBanners.json'
export const getHomepageBanner = () => banners?.[0]
